import { WAIT_STATE } from '@/views/Delivery/kitchenWaitConstants'
import { WAIT_COLOR, waitColor } from './kitchenWaitCounter'

export function summarizeRoutes (routes) {
  const waiting = routes.filter((route) => route.state === WAIT_STATE.WAITING)

  return {
    waiting: waiting.length,
    exceeded: waiting.filter((route) => waitColor(route.wait_seconds) === WAIT_COLOR.RED).length,
    departed: routes.filter((route) => route.state === WAIT_STATE.STARTED).length
  }
}
